<template>
    <div class="" style="">
        <div class="topImgContent">
            <div class="topImgTitleContent">
                <div class="topImgTitle">创新案例</div>
                <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
                <div class="e-flex menuContent">
                    <img class="ic_home" src="@/assets/images/ic_home.png">
                    <div class="pointer" @click="goMainPage()">首页</div>
                    <div>/</div>
                    <div class="pointer" @click="$router.push({ path: (from && from == 1) ? '/index/index' : '/innovationCase/index', query: {}})">创新案例</div>
                    <div>/</div>
                    <div>正文</div>
                </div>
            </div>
        </div>
        <div class="e-flex trpsd_detailContent">
            <div class="trpsd_detailContentWhite">
                <div class="trpsd_detailTop">
                    <div class="trpsd_detailTitle">{{ info.title }}</div>
                    <div class="trpsd_detailDate">{{ info.publishDate ? info.publishDate.replace('-','年').replace('-','月') + '日' : ''}}</div>
                </div>
                <div class="trpsd_detailContentText" v-html="info.content"></div>
            </div>
        </div>
        <div class="pd_paginationNewsContent e-flex">
          <div class="pd_paginationWhiteContent">
              <div class="changePageList e-flex" v-if="prevInfo" @click="changeList(prevInfo)">
                <img class="pageCHangeIcon" src="@/assets/images/ic_top.png">
                <div class="changePageLabel">上一篇</div>
                <div class="changePageCommon e-line-1">{{ prevInfo.title }}</div>
              </div>
              <div class="changePageList e-flex" v-if="nextInfo" @click="changeList(nextInfo)">
                <img class="pageCHangeIcon" src="@/assets/images/ic_down.png">
                <div class="changePageLabel">下一篇</div>
                <div class="changePageCommon e-line-1">{{ nextInfo.title }}</div>
              </div>
          </div>
        </div>
    </div>
  </template>
  
  <script>
    import '../../styles/twoRegionPolicy.css'
    export default {
      name: 'innovationCaseDetail',
      data () {
        return {
          from: '',
          id: '',
          info: {},
          prevInfo: null,
          nextInfo: null
        }
      },
      created() {
        this.from = this.$route.query.from
        this.id = this.$route.query.id
        this.getDetail()
        this.getLastNext()
      },
      methods: {
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        getDetail() {
          this.request({
            url: 'innovativeCase/detail',
            method: 'POST',
            data: {
              id: this.id
            }
          }).then(res => {
            this.info = res.data
          })
        },
        getLastNext() {
          this.request({
            url: 'innovativeCase/lastNext',
            method: 'POST',
            data: {
              id: this.id
            }
          }).then(res => {
            this.lastNextList = res.data
            this.lastNextList.forEach((item, index, array) => {
              if (item.id > this.id) {
                this.prevInfo = item
              } else {
                this.nextInfo = item
              }
            })
          })
        },
        changeList(item) {
          this.id = item.id
          this.prevInfo = null
          this.nextInfo = null
          this.getDetail()
          this.getLastNext()
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/innovationCase/innovationCaseDetail.vue